import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameVideoList = paths['/v3/game/{slug}/articles/video/'];

const getGameVideoList = createRequest<GameVideoList>('/pc/v3/game/{slug}/articles/video/');

export default getGameVideoList;
